
    <div class="content-container pt-0">
        <div class="row">
            <div class="mat-subheader-clients-added f18" mat-subheader>LCA Case No. {{lca?.caseNumber}}
            </div>
         </div>
        <div class="row">
            <div class=" f18" >Certified - 
                <span class="valueTxt ml-1" *ngIf="lca.isCertifiedLCA; else notCrtified"> Yes</span>
                <ng-template #notCrtified>
                    <span class="valueTxt ml-1" notCrtified="lca.isCertifiedLCA">No</span>
                </ng-template>
            </div>
        </div>
         
        <!-- <app-withdraw-lca *ngIf="lcaObj" [lca]="lcaObj" (hideEditButton)="hideEditButtonHandler($event)"></app-withdraw-lca> -->
        <div class="content-container pt-2 dashed-line mb-4 pl-0 pr-0">
        <div class="row">
            <div class="col-md-10 pl-0">
                <div class="row font-weight-bold text-primary">
                   <h5 class="labelText mt-2"> LCA Details </h5>
                </div>
            </div>
            <div class="col-md-2 pr-0">
                <div class="d-flex flex-row-reverse" *ngIf="(lca?.id) ? (lca?.status?.code !== 'LCAASSIGN'): true">
                    <div> <button class="im-btn im-btn-with-icon button_whitebg im-btn-outline-primary" (click)="enableEditMode()" [disabled]="enableReadOnlyMode">
                        <i class="fa fa-pencil"></i>
                        Edit</button></div>
                </div>
            </div>
        </div>
      </div>
        <!-- <div class="d-flex flex-row-reverse">
                  
            <div class="p-2"  *ngIf="lca.id"> <button class="btn btn-outline-dark icn" (click)="enableEditMode()" [disabled]="enableReadOnlyMode">Edit</button></div>
            
        </div> -->

     <div class="content-container pt-0 pl-0 pb-0">
         <div class="dashed-line mb-4">
       <h5 class="labelText">Employment-Based Nonimmigrant Visa Information
        </h5>
        <div class="form-row headrgap mt-2">
            <div class="form-group col-md-6">
                <label class="row">Visa Classification Type</label>
                <div class="row valueTxt">{{lca?.visaType}}</div>
            </div>
        </div>
    </div>
    <div class="dashed-line mb-4">
        <h5 class="labelText">
            Temporary Need Information
        </h5>
        <div class="form-row headrgap pt-2">
            <div class="form-group col-md-4">
                <label class="row">Job Title</label>
                <div class="row valueTxt">{{lca?.jobTitle}}</div>
            </div>
            <div class="form-group col-md-4">
                <label class="row">SOC (ONET/OES) code</label>
                <div class="row valueTxt">{{lca?.socCode}}</div>
            </div>
            <div class="form-group col-md-4">
                <label>SOC (ONET/OES) occupation title</label>
                <div class="row valueTxt">{{lca?.socTitle}}</div>
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-md-4">
                <label class="row">Is this a full-time position?</label>
                <div class="row valueTxt">{{lca?.isFullTime ? 'Yes' : 'No'}}</div>
            
            </div>

            <div class="form-group col-md-4">
                <label class="row">Employment Start Date</label>
                <div class="row valueTxt">{{lca?.employmentStartDate | ImgDateFormat}}</div>
               
            </div>
            <div class="form-group col-md-4">
                <label class="row">Employment End Date</label>
                <div class="row valueTxt">{{lca?.employmentEndDate | ImgDateFormat}}</div>
               
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-4">
                <label class="row">Total Worker Positions</label>
                <div class="row valueTxt"> {{lca?.totalCount}}</div>
            </div>
        </div>

        <div class="row">
            <label class="mat-radio-label-content pl-0">Indicate total workers in each applicable category</label>
        </div>
        <div class="form-row headrgap">
            <div class="form-group col-md-4">
                <label class="row">New Employment</label>
                <div class="row valueTxt">{{lca?.newEmploymentCount}}</div>
            </div>
            <div class="form-group col-md-4">
                <label class="row">Continution of Employment</label>
                <div class="row valueTxt">{{lca?.continueApprovedCount}}</div>
            </div>
            <div class="form-group col-md-4">
                <label class="row">Change in Employment</label>
                <div class="row valueTxt">{{lca?.changeApproveCount}}</div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-4">
                <label class="row">New Concurrent Employment</label>
                <div class="row valueTxt"> {{lca?.concurrentEmploymentCount}}</div>
            </div>
            <div class="form-group col-md-4">
                <label class="row">Change in Employer</label>
                <div class="row valueTxt">{{lca?.employerChangeCount}}</div>
            </div>
            <div class="form-group col-md-4">
                <label class="row">Amended Petition</label>
                <div class="row valueTxt">{{lca?.amendedPetitionCount}}</div>
            </div>
        </div>
    </div>

    <div class="dashed-line mb-4 pb-2">
        <h5 class="labelText">Employer Information</h5>

        <div class="form-row headrgap">
            <div class="form-group col-md-6">
                <label class="row">Company Name</label>
                <div class="row valueTxt">{{lca?.company?.companyName}}</div>
        
            </div>
        </div>
        <!-- <div class="row pb-2">
        <a (click)="toggleExpansion()" class="text-primary f12">
            <span *ngIf="!expandPanel">
                <mat-icon matTooltip="View Company Details">expand_more</mat-icon>
                View company details
            </span>
            <span *ngIf="expandPanel">
                <mat-icon matTooltip="Hide Company Details">keyboard_arrow_up</mat-icon> 
                Hide company details
            </span>
        </a>
       </div> -->
        <mat-accordion>
            <mat-expansion-panel hideToggle [expanded]="expandPanel">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                      <b>View company details</b>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
            <div *ngIf="userType != 'Attorney'">  
                <div class="form-row mt-2">
                    <div class="form-group col-md-4">
                <label class="control-lbl">Federal Employer Identification Number</label>
                <div class="row">{{employerInfo?.feiNo}}</div>
                
                    
            </div>
            <div class="form-group col-md-4">
                <label class="control-lbl">NAICS Code</label>
                <div class="row">{{employerInfo?.newNaicsCode}}</div>
            </div>
        </div>

        <div class="form-row">
           
            <div class="form-group col-md-4">
                <label class="control-lbl">Phone Number</label>
                <div class="row"> {{employerInfo?.phoneContacts[0]?.phoneNo}}</div>
            </div>
            <div class="form-group col-md-4">
                <label class="control-lbl">Ext </label>
                <div class="row"> {{employerInfo?.phoneContacts[0]?.extension}}</div>
            </div>
        </div>
        <div class="row ">
            
            <div class="form-group col-md-6 pl-0" >
                <label class="control-lbl">Address</label>
                <div class="row"> {{employerInfo?.address[0]?.addressLine1}}</div>
                <div class="row"> {{employerInfo?.address[0]?.addressLine2}}</div>
                <div class="row"> {{employerInfo?.address[0]?.countryCode?.countryName}}</div>
                <div class="row"> {{(employerInfo?.address[0]?.stateProvinceCode) ? employerStateName : '--' }}</div>
                <div class="row">  {{employerInfo?.address[0]?.city}} -  {{employerInfo?.address[0]?.postCode}}</div>
            </div>
        </div>

      
        </div>
        <div class="panel-border pt-2" *ngIf="this.userType === 'Attorney'">  
       

            <div class="form-row mt-2">
                <div class="form-group col-md-4">
                    <label>Federal Employer Identification Number</label>
                    <div class="row">{{petitionerInfo?.feiNo}}</div>
                    
                        
                </div>
                <div class="form-group col-md-4">
                    <label>NAICS Code</label>
                    <div class="row">{{petitionerInfo?.newNaicsCode || petitionerInfo?.naicsCode}}</div>
                </div>
            </div>
    
            <div class="form-row">
               
                <div class="form-group col-md-4">
                    <label>Phone Number</label>
                    <div class="row"> {{petitionerInfo?.petitionerOfficePhone}}</div>
                </div>
                <div class="form-group col-md-4">
                    <label>Ext </label>
                    <div class="row"> {{petitionerInfo?.petitionerPhoneExtension}}</div>
                </div>
            </div>
            <div class="row ">
                
                <div class="form-group col-md-6 pl-0" >
                    <label>Address</label>
                    <div class="row"> {{petitionerInfo?.petitionerRegisteredAddress?.addressLine1}}</div>
                    <div class="row"> {{petitionerInfo?.petitionerRegisteredAddress?.addressLine2}}</div>
                    <div class="row"> {{petitionerInfo?.petitionerRegisteredAddress?.countryCode?.countryName}}</div>
                    <div class="row"> {{petitionerInfo?.petitionerRegisteredAddress?.stateProvinceCode}}</div>
                    <div class="row">{{petitionerInfo?.petitionerRegisteredAddress?.city}} -  {{petitionerInfo?.petitionerRegisteredAddress?.postCode}}</div>
                </div>
            </div>
    
          
            </div>
        </mat-expansion-panel>
        </mat-accordion>
       
        <!-- <div class="row font-weight-bold text-primary linde-divider dasheedTopBorder pt-2">
          
            Enter the purpose for the LCA
           
        </div> -->
    </div>
 

    <div class="dashed-line pb-2">
        <mat-accordion>
            <mat-expansion-panel hideToggle [expanded]="expandPanel">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                      <b>Places of Employment</b>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div *ngFor="let info of lca.placeOfEmployments; let i = index;" >
                    <h6>{{i+1}}. Place of Employment </h6>

                    <div class="form-row pl-4 mt-2">
                        <div class="form-group col-md-4">
                            <label>AddressLine 1</label>
                            <div class="row">{{info.addressDTO.addressLine1}}</div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>AddressLine 2</label>
                            <div class="row">{{info.addressDTO.addressLine2}}</div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>City</label>
                            <div class="row">{{info.addressDTO.city}}</div>
                        </div>
                    </div> 
                 
                     <div class="form-row pl-4 mt-2">
                   
                        <div class="form-group col-md-4">
                            <label>County</label>
                            <div class="row">{{info.addressDTO.county}}</div>
                        </div>
    
                        <div class="form-group col-md-4">
                            <label> State/District/Territory</label>
                            <div class="row">{{info.addressDTO.stateProvinceName}}</div>
                        </div>

                        <div class="form-group col-md-4">
                            <label>Postal Code </label>
                            <div class="row">{{info.addressDTO.postalCode}}</div>
                        </div>
                    </div> 
           
                    <div class="form-row pl-4 mt-2">
                        <div class="form-group col-md-4">
                            <label>Wage paid to non-immigrant - from</label>
                            <div class="row">{{info.wageRangeFrom}}</div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Wage paid to non-immigrant - to</label>
                            <div class="row">{{info.wageRangeTo}}</div>
                        </div>
 
                        <div class="form-group col-md-4">
                            <label>Wage paid to non-immigrant - per</label>
                            <div class="row">{{getDisplayString(info.wageRangeTypeCode)}}</div>
                        </div>
                    </div> 


                    <div class="form-row pl-4 mt-2">
                        <div class="form-group col-md-4">
                            <label>Prevailing wage paid - rate</label>
                            <div class="row">{{info.prvlWageRate}}</div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Prevailing wage paid - per</label>
                            <div class="row">{{getDisplayString(info.prvWageTypeCode)}}</div>
                        </div>

                        <div class="form-group col-md-4">
                            <label>Prevailing wage level</label>
                            <div class="row">{{getDisplayString(info.prvWageLevelTypeCode)}}</div>
                        </div>
                    </div> 
                    <div *ngIf="i<lca.placeOfEmployments.length-1">
                        <hr/>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

     
        <div>
            <div class="form-group col-md-8 pl-0 pt-2">
                <h5 class="labelText">Notes</h5>
               <div class="row valueTxt">{{lca?.comment}}</div> 
            </div>
         </div>
        <div class="row">
        <!-- <div class="col-md-8 w100 example-element-description py-1" *ngIf="listUploadedFiles.length > 0">
            <h6>List of Documents</h6>
            <ng-container>
              <table class="im-card-no-border-table">
                <thead>
                  <tr>
                    <th class="w40"></th>
                   
                    <th>Document Type</th>
                    <th>Document</th>
                    <th><i class="fa fa-download fa-lg icn" aria-hidden="true"></i></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of listUploadedFiles;let i=index">
                    <td class="w40">
                      <div class="circleIndex rounded-circle">{{i+1}}
                      </div>
                    </td>
                    <td nowrap>
                        {{ item?.fileCategory?.name }}
                      </td>
                    <td>
                      <strong>{{ item?.fileName }}</strong>
                    </td>
                   
                    <td nowrap>
                      <a *ngIf="item.fileLocation" [href]="envPath + item.fileLocation.substring(23)" target="_blank"
                        download>
                        <i class="fa fa-download fa-lg icn" aria-hidden="true"></i>
                      </a>
                       <a  (click)="download(envPath + item.fileLocation.substring(23))" >
                    <i class="fa fa-download fa-lg icn" aria-hidden="true"></i>
                  </a> 
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </div> -->
          <div class="client-display-box col-md-10">
            <mat-list *ngIf="assignmentList && assignmentList.length >0"
              class="client-list-print">
              <div class="mat-subheader-clients-added pl-0" mat-subheader>LCA Assignment Details</div>
              <mat-list-item>
                      <div class="clients-list-item-partition">
                          <div mat-line>Task ID</div>
                      </div>     
                       <div class="clients-list-item-partition">
                           <div mat-line>Beneficairy Name</div>
                       </div>     
                       <div class="clients-list-item-partition">
                           <div mat-line>Visa Type</div>
                       </div>     
                         
                       <div class="clients-list-item-partition">
                           <div mat-line>Petition Type</div>                                         
                       </div>     
                   </mat-list-item>   
              <mat-list-item *ngFor="let item of assignmentList;
         let i = index;let even = even;let first = first;let last = last;"
                  [ngClass]="{'evenBg':even,'border-top-radius':first,'border-bottom-radius':last}">
                  <div class="clients-list-item-partition">
                    <div mat-line>   {{ item?.superTaskId }} </div>
                 
                  </div>
  
                  <div class="clients-list-item-partition">
                      <div mat-line>   {{ item?.beneficiaryFirstName }} {{ item?.beneficiaryMiddleName }} {{ item?.beneficiaryLastName }} </div>
                  </div>
  
                  <div class="clients-list-item-partition">
                      <div mat-line> {{item?.visaTypeCode}} </div>
                  </div>
  
                
  
                  <div class="clients-list-item-partition">
                      <div mat-line>
                        {{item?.petitionTypeName}} 
                        
                      </div>
                  </div>
  
              </mat-list-item>
          </mat-list>
          </div>

          <div class="client-display-box col-md-10 mb-2">
          <mat-list *ngIf="listUploadedFiles && listUploadedFiles.length >0"
            class="client-list-print">
            <div class="mat-subheader-clients-added pl-0" mat-subheader>List of Documents</div>
            <mat-list-item>
                    <div class="first-item">
                        <div mat-line></div>
                    </div>     
                     <div class="clients-list-item-partition">
                         <div mat-line>Document Type</div>
                     </div>     
                     <div class="clients-list-item-partition">
                         <div mat-line>Document</div>
                     </div>     
                       
                     <div class="clients-list-item-partition">
                         <div mat-line></div>                                         
                     </div>     
                 </mat-list-item>   
            <mat-list-item *ngFor="let item of listUploadedFiles;
       let i = index;let even = even;let first = first;let last = last;"
                [ngClass]="{'evenBg':even,'border-top-radius':first,'border-bottom-radius':last}">
                <div class="first-item">
                <div class="numberCircle">{{i+1}}</div>
                </div>

                <div class="clients-list-item-partition">
                    <div mat-line>   {{ item?.fileCategory?.name }} </div>
                </div>

                <div class="clients-list-item-partition">
                    <div mat-line> {{item?.fileName}} </div>
                </div>

              

                <div class="clients-list-item-partition">
                    <div mat-line class="text-right">
                        <!-- <mat-icon class="delete-client-entry">
                            download
                        </mat-icon> -->
                        <a *ngIf="item.fileLocation" [href]="envPath + item.fileLocation.substring(23)" target="_blank"
                        download>
                        <i class="fa fa-download fa-lg icn" aria-hidden="true"></i>
                      </a>
                      
                    </div>
                </div>

            </mat-list-item>
        </mat-list>
        </div>


        </div>

        </div>
    </div>
    

   





